<template lang="pug">
.box
    header.flex.items-center.justify-between.box__header.no-border
        .header-meta
            h2.subheading List Data
        .header-cta
            button.btn-default Export to excel

    template(v-if="load_data_status_location_count.history === 'loading'")
        Loading(show="true")
    template(v-else) 
        NoDataAvailable(v-if='filterNull')
        template(v-else-if="location_history && location_history.length > 0")
            .box__body.p-4
                <v-client-table ref='myTable' :data="tableData" :columns="columns" :options="options">
                    <span slot="no" slot-scope="props">{{props.index}}.</span>
                </v-client-table>  
        NoDataAvailable(v-else)
</template>

<script>
// import VueTableDynamic from 'vue-table-dynamic'
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

// const random = () => {
//   return parseInt(Date.now() + Math.random() * 10000000).toString(16).slice(-6)
// }

export default {
    name: 'TableDataLocation',
    components: {
        // VueTableDynamic,
        Loading,
        NoDataAvailable,
    },
    data() {
        return {
            // params: {
            //     data: [
            //         [`Data1`, `Data2`, `Data3`, `Data4`, `Data5`, `Data6` ]
            //     ],
            //     header: 'row',
            //     border: false,
            //     stripe: true,
            //     enableSearch: true,
            //     fixed: 0
            // },
            filterNull: false,
            columns: ['datetime','time','provider','rat_name','country','province','village','mcc','mnc','city','region','lac','ci','msisdn','imsi','bts','geoloc'],
            options: {
                headings: {
                    'datetime': 'Datetime',
                    'time': 'Time',
                    'provider': 'Provider',
                    'rat_name': 'Rat Name',
                    'country': 'Country',
                    'province': 'Province',
                    'village': 'Village',
                    'mcc': 'MCC',
                    'mnc': 'MNC',
                    'city': 'City',
                    'region': 'Region',
                    'lac': 'LAC',
                    'ci': 'CI',
                    'msisdn': 'MSISDN',
                    'imsi': 'IMSI',
                    'bts': 'BTS',
                    'geoloc': 'GEOLOC',
                },
                // filterable: false,
                // perPage: 10,
                pagination: { 
                    chunk: 5 
                    // dropdown: false 
                },
                // perPageValues: [10,25,50,100],
                skin: 'table table-overflow',
                // skin: 'table-static w-full p-4',
                sortIcon: { 
                    base:'iconfont',
                    is:'iconsort',
                    up: 'iconup',
                    down: 'icondown'
                },
                columnsClasses: {
                  'datetime': 'font-mini',
                },
            },
            tableData:[]
        };
    },
    computed: {
        ...mapState([
          // 'load_data_status_location',
          'load_data_status_location_count',
          'location_history',
        ]),
    },
    watch:{
        location_history() {
            this.getData();
        }
    },
    methods: {
        getData() {
            if (this.location_history && this.location_history.length > 0) {
                var location_history = this.location_history;
                location_history = location_history.filter(function(item) {
                    if (item.geoloc && item.geoloc.length > 0 ) {
                        let geoloc = item.geoloc;
                        // item.geoloc = item.geoloc.join(', ');
                        // item.geoloc = item.geoloc[0]+', '+item.geoloc[1];

                        // console.log(geoloc[0]);
                        // console.log(geoloc[1]);
                        // console.log(geoloc[0]+', '+geoloc[1]);
                        item.geoloc = (geoloc[0] && geoloc[1] ? geoloc[0]+', '+geoloc[1] : '-');
                    }
                    
                    return item;
                });
                this.tableData = location_history;

                this.filterNull = false;
            } else {
                this.filterNull = true;
            }
        },
    },
    mounted () {
        // for (let i = 0; i < 5; i++) {
        //     this.params.data.push([`${random()}`, `${random()}`, `${random()}`,  `${random()}`, `${random()}`, `${random()}`])
        // }
        this.getData();
    },
}
</script>

<style lang="sass">
@import "./../../../assets/sass/components/table-overflow.sass"
</style>
